import { OverlayImplementation } from '../../../libs/gin-tonic/helpers/overlay/overlay-implementation';
import { OverlayOptions } from '../../../libs/gin-tonic/helpers/overlay/overlay-options';
import { OverlayPositionBuilder } from '../../../libs/gin-tonic/helpers/overlay/position/overlay-position-builder';

export class ProductStock extends OverlayImplementation {
	constructor(element: HTMLElement) {
		super(element);
		this.element.addEventListener('mouseenter', e => this.open(e.target as HTMLElement));
		this.element.addEventListener('mouseleave', () => this.close());
	}

	getOverlayOptions(): OverlayOptions {
		return {
			positionStrategy: OverlayPositionBuilder.connectedTo(this.element)
				.withFallbackPosition(
					{
						originX: 'center',
						originY: 'top'
					},
					{
						overlayX: 'center',
						overlayY: 'bottom'
					}
				)
				.withFallbackPosition(
					{
						originX: 'center',
						originY: 'bottom'
					},
					{
						overlayX: 'center',
						overlayY: 'top'
					}
				)
				.withOffsetY(-8),
			overlayClassName: 'c-product-stock__panel',
			portalClassName: 'c-product-stock__portal',
			hasBackdrop: false,
			disposeAfterClose: true
		};
	}

	initializePortal(portal: HTMLElement): void {
		const element = document.getElementById(this.element.dataset.stock);

		portal.innerHTML = element.outerHTML;
	}
}
